import { RefreshCw, Home, AlertTriangle } from 'lucide-react';

interface ErrorFallbackProps {
  resetError: () => void;
}

export function ErrorFallback({ resetError }: ErrorFallbackProps) {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-gradient-to-b from-white to-gray-50 px-5 py-12">
      <div className="flex flex-col items-center justify-center space-y-6 max-w-sm">
        {/* Ícone animado */}
        <div className="relative">
          <div className="absolute inset-0 bg-orange-100 rounded-full blur-2xl opacity-50 animate-pulse" />
          <div className="relative bg-orange-50 rounded-full p-8">
            <AlertTriangle className="w-20 h-20 text-orange-500" strokeWidth={1.5} />
          </div>
        </div>

        {/* Título e descrição */}
        <div className="flex flex-col items-center space-y-1 text-center">
          <h2 className="text-lg font-semibold text-gray-900">
            Ops! Algo inesperado aconteceu
          </h2>
        </div>

        {/* Botões de ação */}
        <div className="flex flex-col w-full space-y-3 pt-2">
          <button
            onClick={resetError}
            className="flex items-center justify-center gap-2 w-full bg-primary text-primary-foreground rounded-xl py-3 px-4 font-medium text-sm hover:bg-primary/90 transition-colors clickable-button"
          >
            <RefreshCw className="w-4 h-4" />
            Recarregar página
          </button>
          <button
            onClick={handleGoHome}
            className="flex items-center justify-center gap-2 w-full bg-gray-100 text-gray-700 rounded-xl py-3 px-4 font-medium text-sm hover:bg-gray-200 transition-colors clickable-button"
          >
            <Home className="w-4 h-4" />
            Voltar para início
          </button>
        </div>
      </div>
    </div>
  );
}
